import * as React from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { TabUnderlineSettings } from '../../interfaces';

import { Container, Header, StyledTabUnderline, TabsContainer } from './accountHeadline.styled';
import { AccountHeadlineProps } from './accountHeadline.types';

export const AccountHeadline: React.FC<AccountHeadlineProps> = (props: AccountHeadlineProps): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const { username, tabs, className }: AccountHeadlineProps = props;

  return (
    <Container className={className}>
      <Header as="h1">{t('onarte.ui.accountHeadline.header', { username })}</Header>
      <TabsContainer>
        {tabs.map((tab: TabUnderlineSettings): JSX.Element => (
          <StyledTabUnderline tabSettings={tab} key={tab.label} />
        ))}
      </TabsContainer>
    </Container>
  );
};
